import React, { useCallback, useContext, useEffect, useRef } from "react"
import SKLand from "@skland/one-bridge"
import anime from "animejs"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"
import { useShowRoleSelect } from "@hg/one-account"

import { GlobalContext } from "../../context"

import styles from "./index.module.less"

interface IProps {
    visible?: boolean
    className?: string
    needAnimeDelay?: boolean
}

const Menu: React.FC<IProps> = (props) => {
    const { visible, className, needAnimeDelay = true } = props

    const {
        state: { bgm, hasRole },
        dispatch,
    } = useContext(GlobalContext)

    const showRoleSelect = useShowRoleSelect()

    const handleClickLogin = useCallback(() => {
        if (visible) {
            // 无角色 且 在森空岛内
            if (!hasRole && SKLand.getSystemInfo().isApp) {
                showRoleSelect()
                return
            }

            dispatch({
                type: "updateContext",
                payload: {
                    showRegistry: true,
                },
            })
        }
    }, [dispatch, hasRole, showRoleSelect, visible])

    const handleClickHome = useCallback(() => {
        if (visible) {
            window.open("https://arknights.global/", "_blank")
        }
    }, [visible])

    const handleClickMusic = useCallback(() => {
        if (visible) {
            dispatch({
                type: "updateContext",
                payload: {
                    bgm: !bgm,
                },
            })
        }
    }, [visible, dispatch, bgm])

    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const ele = containerRef.current
        if (!ele || !visible) return
        const items = ele.querySelectorAll(`.${styles.menuItem}`)
        const inst = anime.timeline()
        items.forEach((item, index) => {
            inst.add(
                {
                    targets: item,
                    duration: 500,
                    opacity: [0, 1],
                    delay: needAnimeDelay ? index * 100 : 0,
                    easing: "easeOutCubic",
                },
                0
            )
        })
    }, [visible, needAnimeDelay])

    return (
        <SafeAreaView
            ref={containerRef}
            mode="margin"
            edges={["right"]}
            className={classNames(styles.menu, className)}
        >
            <div
                className={classNames(styles.menuItem, styles.login)}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickLogin()
                }}
            >
                <div className={styles.icon} />
            </div>
            <div
                className={classNames(styles.menuItem, styles.home)}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickHome()
                }}
            >
                <div className={styles.icon} />
            </div>
            <div
                className={classNames(
                    styles.menuItem,
                    styles.bgm,
                    !bgm && styles.off
                )}
                onClick={(e) => {
                    e.stopPropagation()
                    handleClickMusic()
                }}
            >
                <div className={styles.icon} />
            </div>
        </SafeAreaView>
    )
}

export default Menu
